import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../api/index.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load user on mount if a token exists
  useEffect(() => {
    const token = localStorage.getItem('mg_token');
    if (!token) {
      setLoading(false);
      return;
    }
    api.users
      .me()
      .then(setUser)
      .catch(() => localStorage.removeItem('mg_token'))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback((token, userData) => {
    localStorage.setItem('mg_token', token);
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('mg_token');
    setUser(null);
  }, []);

  const refreshUser = useCallback(() => {
    return api.users.me().then(setUser);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}
